import styled from 'styled-components';

export const StyledRoomControl = styled.div.attrs(props => ({
  className: props.className
}))`
  width: 100%;
`;